import _ from "lodash"
import { getFeatureDetail } from "utils/feature"
import { VERTICAL_TRAVERSAL_CATEGORY } from "constant"

export const createDescription = (
  comingFrom,
  goingTo,
  intermediary,
  nearestLandmark,
  isLastStep?: boolean
) => {
  const destFeatureType = _.get(goingTo, "feature_type")
  const destFeatureCategory = _.get(goingTo, "properties.category")
  const categoryOption = `${destFeatureType}.${destFeatureCategory}`

  if (
    intermediary.every((unit) => unit.properties.category === "escalator") ||
    intermediary.every((unit) => unit.properties.category === "stairs") ||
    intermediary.every(
      (unit) => unit.properties.category === "stairs.emergencyexit"
    ) ||
    (intermediary.every((unit) => unit.properties.category === "elevator") &&
      comingFrom.properties.ordinal !== goingTo.properties.ordinal)
  ) {
    const [intermediate] = intermediary

    return {
      text:
        comingFrom.properties.ordinal < goingTo.properties.ordinal
          ? "To upper level"
          : "To lower level",
      options: {
        category: `${intermediate.feature_type}.${intermediate.properties.category}`,
        destination:
          goingTo.properties?.level_name ||
          goingTo.properties?.level?.properties?.name?.en ||
          goingTo.properties?.level?.properties?.name,
      },
    }
  }

  if (isLastStep) {
    return {
      text: "To destination",
    }
  }

  if (destFeatureType === "occupant") {
    return {
      text: "To traverse",
      options: {
        destination: _.get(getFeatureDetail(goingTo), "name"),
      },
    }
  }

  if (
    destFeatureType === "unit" &&
    VERTICAL_TRAVERSAL_CATEGORY.includes(destFeatureCategory)
  ) {
    const isLandmarkOccupant = nearestLandmark?.feature_type === "occupant"
    if (isLandmarkOccupant) {
      return {
        text: "To traverse with landmark",
        options: {
          category: categoryOption,
          landmark: _.get(getFeatureDetail(nearestLandmark), "name"),
        },
      }
    }
    return {
      text: "To traverse",
      options: {
        destination: categoryOption,
      },
    }
  }

  if (destFeatureType === "unit" && destFeatureCategory === "walkway") {
    return {
      text: "To traverse with walkway",
    }
  }

  return {
    text: "To traverse",
    options: {
      destination: _.get(getFeatureDetail(goingTo), "name"),
    },
  }
}
